export default __webpack_public_path__ + "static/media/CourseFlow.04c4a02f.jpg";